(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-review-registration]').forEach((form) => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      const email = form.elements.namedItem('email');
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[role="status"]');
      button.disabled = false;
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!form.reportValidity() || button.disabled) return;
        if (form.elements.namedItem('website').value) return;
        const endpoint = new URL(form.dataset.endpoint);
        const destination = new URL(form.dataset.reviewUrl);
        if (endpoint.origin !== 'https://hook.eu1.make.com' || destination.origin !== 'https://judge.me') return;
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        status.textContent = form.dataset.sending;
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 15000);
        try {
          const body = new URLSearchParams({
            email: email.value.trim().toLowerCase(),
            campaign: 'reviews10-v1',
            locale: form.dataset.locale,
            source: 'reviews-landing',
            marketing_opt_in: String(form.elements.namedItem('marketing_opt_in')?.checked === true),
            consent_version: 'reviews10-2026-10-27',
            website: '',
            test_mode: form.dataset.testMode,
          });
          const response = await fetch(endpoint.href, {
            method: 'POST', body, signal: controller.signal, credentials: 'omit',
          });
          if (!response.ok) throw new Error('Registration failed');
          const result = await response.json();
          if (result.ok !== true) throw new Error('Registration not acknowledged');
          // The review URL is configured in the theme, never supplied by the public request.
          window.location.assign(destination.href);
        } catch {
          status.textContent = form.dataset.error;
          button.disabled = false;
          form.removeAttribute('aria-busy');
        } finally {
          clearTimeout(timer);
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
